<div class="header-bar">
  <h1>Organisations</h1>
</div>
<div class="content-container">
  <app-organisation-selector-grid
    (organisationSelected)="onOrganisationSelected($event)"
  ></app-organisation-selector-grid>

  <div style="margin-top: 30px">
    <interactions [organisationId]="selectedOrganisationId"></interactions>
  </div>
</div>
